<p class="font-default max-w-full truncate text-5xl leading-none font-bold text-white text-shadow-md">{{ title() }}</p>
